import { defineRouting } from 'next-intl/routing'

export const locales = ['fa', 'en']
export const routing = defineRouting({
  locales: locales,
  defaultLocale: 'fa',
  localeDetection: false,
  localePrefix: 'as-needed',
})
